import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
import { Report } from "./pages/Report";
import { SendCoupon } from "./pages/SendCoupon";
import { CancelCoupon } from "./pages/CancelCoupon";
import { ImportSendCoupon } from "./pages/component/ImportSendCoupon";
export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {<Redirect exact from="/" to="/Report" />}
        <ContentRoute path="/Dashboard" component={DashboardPage} />
        <ContentRoute path="/Report" component={Report} />
        <ContentRoute path="/SendCoupon" component={SendCoupon} />
        <ContentRoute path="/CancelCoupon" component={CancelCoupon} />
        <ContentRoute path="/ImportSendCoupon" component={ImportSendCoupon} />

        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}
